// src/components/LayerPanel/SeriesCoverageLine.jsx
//
// One-line summary under a series title: total county count with bucket
// breakdown, plus a chevron that opens the county-detail flyout. The flyout
// itself lives at the panel level so multiple SeriesRows don't fight over
// "which one is open" state.
//
// Mounted as a SIBLING of the series-row title button so the chevron isn't a
// nested <button>. stopPropagation on the chevron is still set defensively —
// future layout work could wrap us in a click handler.

import { ChevronRight } from "lucide-react";
import {
  bucketCounties,
  formatCoverageSummary,
} from "../../layers/imagery/coverageBuckets";

export default function SeriesCoverageLine({ series, onOpenFlyout }) {
  const counties = series?.counties;

  // No AOI context — caller filters, but be defensive so the component is
  // safe to render unconditionally.
  if (!counties) return null;

  if (counties.length === 0) {
    return (
      <div className="text-[10px] text-fg-secondary italic px-2 pb-1.5 leading-snug">
        No coverage in your AOI
      </div>
    );
  }

  const summary = formatCoverageSummary(bucketCounties(counties));
  if (!summary) return null;

  return (
    <div className="flex items-center px-2 pb-1.5 leading-snug">
      <span className="text-[10px] text-gray-400 flex-1 min-w-0 truncate">
        {summary}
      </span>
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onOpenFlyout?.(series);
        }}
        aria-label="Show county coverage details"
        className="ml-1 p-0.5 -mr-0.5 text-fg-secondary hover:text-gray-200 transition flex-shrink-0"
      >
        <ChevronRight size={12} />
      </button>
    </div>
  );
}
